import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constants } from '@app/constants';
import { AppNames } from '@app/models/AppNames';
import { IHubData } from '@app/models/hub-data.model';
import { Observable, of } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

declare const window: {
  data: IHubData;
};

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  constructor(private http: HttpClient) {}

  // SAVE enable for local dev, disable for production
  /**
   * Gets token
   * @returns token
   */
  public getToken(): Observable<any> {
    if (
      (environment.type === 'local' ||
        environment.type === 'dev' ||
        environment.type === 'qa') &&
      sessionStorage.getItem('appName') === AppNames.UNITY_EXPRESS
    ) {
      const body = new URLSearchParams();
      const userName =
        localStorage.getItem('username') ||
        Constants.appConfiguration.localTokenEmail;
      const password =
        localStorage.getItem('password') ||
        Constants.appConfiguration.localTokenPassword;
      body.set('username', userName);
      body.set('grant_type', 'password');
      body.set('password', password);
      body.set('scope', Constants.appConfiguration.scope);
      body.set('client_id', 'Api');
      body.set('client_secret', 'Secret');

      const options = {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        )
      };
      return this.http
        .post<{
          access_token: string;
        }>(
          `${Constants.appConfiguration.identityRoot}/token`,
          body.toString(),
          options
        )
        .pipe(
          debounceTime(5000),
          map(res => {
            localStorage.setItem('access_token', res.access_token);
            localStorage.setItem('losId', window.data.LosId);
            return of([]);
          })
        );
    } else if (sessionStorage.getItem('appName') === AppNames.UNITY_EXPRESS) {
      debounceTime(5000),
        localStorage.setItem('access_token', window.data.token);
      localStorage.setItem('losId', window.data.LosId);
    }
    return of([]);
  }
}
